import React, { Component } from 'react'
import axios from 'axios'
import { sn_url } from '../../utils/js/endpoints'
import { handleError } from 'utils/js/error_helpers'

import './Providers.scss'

class Providers extends Component {
    constructor() {
        super()
        this.getChannels_source = null
        this.state = {
            channelsStatus: '',
        }
    }

    componentDidMount() {
        this.mounted = true
    }

    componentWillUnmount() {
        this.mounted = false
        if (this.getChannels_source) this.getChannels_source.cancel()
    }

    selectProvider = e => {
        let val = e.target.value
        if (!val) return null

        this.getChannels(val)
    }

    getChannels = provider_id => {
        if (!provider_id) return null

        this.getChannels_source = axios.CancelToken.source()

        this.setState({
            channelsStatus: 'loading',
        })

        let endpoint = `${sn_url}/wp-admin/admin-ajax.php?action=get_tv_channels&providerID=${provider_id}`

        axios
            .get(endpoint, {
                cancelToken: this.getChannels_source.token,
                headers: { 'Content-Type': 'application/json' },
            })
            .then(response => {
                if (this.mounted) {
                    //reset state first
                    this.setState(
                        {
                            channelsStatus: '',
                        },
                        () => {
                            this.props.addChannels(response.data)
                            this.props.modalToggle()
                        }
                    )
                }
                this.getChannels_source = null
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    this.setState({
                        channelsStatus: 'error',
                    })
                }
                handleError(error)
                this.getChannels_source = null
            })
    }

    render() {
        const { providers } = this.props

        if (this.state.channelsStatus === 'error') {
            return (
                <div className="Providers__cont">
                    <div className="error_overlay" />
                </div>
            )
        }

        return (
            <div className="Providers__cont">
                <h2>Find My Channels</h2>
                <select value="" onChange={this.selectProvider}>
                    <option value="">Choose a Provider</option>
                    {providers &&
                        providers.length !== 0 &&
                        providers.map((provider, i) => {
                            return (
                                <option key={i} value={provider.lineupID}>
                                    {provider.lineupName}
                                </option>
                            )
                        })}
                </select>
                {this.state.channelsStatus === 'loading' && <div className="loading_overlay" />}
            </div>
        )
    }
}

export default Providers
